<!-- 代订舱中转页 -->
<template>
  <div v-loading="true" class="page-transfer">
    跳转中...
  </div>
</template>

<script>
  import { getToken } from "@/utils/auth";

  export default {
    data() {
      const { username, password } = this.$route.query
      return {
        isLogin: !!getToken(),
        loginForm: {
          username,
          password,
          appCode: "CTS_WEB",
          isExternal: 1,
          isActive: 1,
        },
      }
    },

    created() {
      // 强制登录（可能登录其他账号；登录态失效不会跳转登录页）
      // if (this.isLogin && !this.$route.query.forceLogin) {
      //   this.$router.push(this.$route.query.redirect || '/')
      //   return
      // }

      this.login()
    },

    methods: {
      async login() {
        const res = await this.$store.dispatch('user/login', this.loginForm).catch((err) => {
          this.$coreMethods.message('登录失败出错，请稍后重试！')
          console.warn('登录出错：', err)
        })

        if (!res || !res.success) {
          this.$coreMethods.message('登录失败：', res.errorMessages[0])
          return
        }

        // 进入页面前先判断并添加动态路由
        if (!this.$store.state.user.isAddRouters) {
          await this.$store.dispatch('user/getMenu')
        }
        const redirect = this.$route.query.redirect
        this.$router.push(redirect ? decodeURIComponent(redirect) : '/')
      },
    },
  }
</script>

<style lang="scss" scoped>
.page-transfer {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  height: 100vh;
}
</style>
